<template>
  <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="350px">
    <el-form :rules="rules" ref="dataForm" :model="formData">
      <el-form-item label="原密码" prop="password">
        <el-input type="password" v-model="formData.password" placeholder="请输入原密码"></el-input>
      </el-form-item>

      <el-form-item label="新密码" prop="newPassword">
        <el-input type="password" v-model="formData.newPassword" placeholder="请输入新密码"></el-input>
      </el-form-item>

      <el-form-item label="确认密码" prop="rePassword">
        <el-input type="password" v-model="formData.rePassword" placeholder="请输入确认密码"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="updateData">确定</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
  import { fetchUpdatePassword} from '@/api/Users/admin'
  export default {
    name: "editAdminPassword",
    data() {
      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          const reg=/^(?![a-zA-z]+$)(?!\d+$)[a-zA-Z\d]+$/;// 字母+数字
          if(!reg.test(value)){
            callback(new Error('请输入字母+数字的密码组合'));
          }else{
            if (this.formData.rePassword !== '') {
              this.$refs.dataForm.validateField('rePassword');
            }
            callback();
          }
        }
      };
      const validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入确认密码'));
        } else if (value !== this.formData.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };

      return {
        dialogFormVisible:false,//是否弹窗修改密码
        formData:{
          password:'',
          newPassword:'',
          rePassword:''
        },
        rules: {
          password: [{required: true, message: '请输入原密码', trigger: 'blur'}],
          newPassword: [{required: true, message: '请输入新密码', trigger: 'blur'}, {validator: validatePass, trigger: 'blur'}],
          rePassword: [{required: true, message: '请输入确认密码', trigger: 'blur'}, {
            validator: validatePass2,
            trigger: 'blur'
          }],
        },
      }
    },
    methods:{
      //设置弹出框状态
      setDialogStatus(status){
        this.dialogFormVisible=status
      },
      //退出登录
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload()// 为了重新实例化VUE路由器对象以避免bug
        })
      },
      //更新密码
      updateData(){
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            let data=this.formData
            delete data.rePassword
            fetchUpdatePassword(data).then((res) => {
              if(res.code==0){
                this.dialogFormVisible = false
                this.$notify({
                  title: '成功',
                  message: '密码修改成功,请重新登录',
                  type: 'success',
                  duration: 2000
                })
                setTimeout(()=>{
                  this.logout()
                },1000)
              }
            })
          }
        })
      }
    }
  };
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/editAdminPassword.vue